<template>
  <div id="QrOrdersLabelMakerByVariantChart"></div>
</template>

<script>
import * as am4core from "@amcharts/amcharts4/core";
import * as am4charts from "@amcharts/amcharts4/charts";
import am4themes_animated from "@amcharts/amcharts4/themes/animated";

am4core.useTheme(am4themes_animated);

export default {
  name: "QrOrdersLabelMakerByVariantChart",
  props: {
    chartData: {
      type: Array,
      required: true,
    },
  },
  data() {
    return {
      chart: null,
      noDataLabel: null,
      colors: ["#8FDCFF"],
    };
  },
  watch: {
    chartData: {
      handler(newData) {
        this.updateChart(newData);
      },
      immediate: true,
    },
  },
  mounted() {
    this.createChart(this.chartData);
  },
  beforeDestroy() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  },
  methods: {
    createChart(data) {
      this.chart = am4core.create("QrOrdersLabelMakerByVariantChart", am4charts.XYChart);
      this.chart.data = data;

      let categoryAxis = this.chart.xAxes.push(new am4charts.CategoryAxis());
      categoryAxis.dataFields.category = "variant";
      categoryAxis.renderer.minGridDistance = 50;
      categoryAxis.renderer.grid.template.location = 0;

      let valueAxis = this.chart.yAxes.push(new am4charts.ValueAxis());
      valueAxis.min = 0;
      valueAxis.renderer.opposite = false;
      valueAxis.numberFormatter.numberFormat = "#";
      valueAxis.maxPrecision = 0;

      valueAxis.title.text = "Total";
      valueAxis.title.rotation = 270;
      valueAxis.title.align = "center";
      valueAxis.title.valign = "center";
      valueAxis.title.dy = 130;

      this.noDataLabel = this.chart.tooltipContainer.createChild(am4core.Label);
      this.noDataLabel.html = `<p style="font-weight: bold; font-size: 1.5rem;">No Data</p>`;
      this.noDataLabel.align = "center";
      this.noDataLabel.valign = "middle";
      this.noDataLabel.horizontalCenter = "middle";
      this.noDataLabel.verticalCenter = "middle";
      this.noDataLabel.hide();

      this.createSeries(this.chart, "value", "Value", this.colors[0]);

      if (this.chart.tooltip) {
        this.chart.tooltip.background.fill = am4core.color("#FFFFFF");
        this.chart.tooltip.background.stroke = am4core.color("#CCCCCC");
        this.chart.tooltip.background.strokeWidth = 1;
        this.chart.tooltip.background.cornerRadius = 4;
        this.chart.tooltip.getFillFromObject = false;
        this.chart.tooltip.label.fill = am4core.color("#000000");
      }

      let cursor = new am4charts.XYCursor();
      this.chart.cursor = cursor;

      this.chart.events.on("datavalidated", () => {
        const isEmpty =
          !this.chart.data ||
          this.chart.data.length === 0 ||
          this.chart.data.every((d) => !d.value || d.value === 0);

        if (isEmpty) {
          this.noDataLabel.show();
          valueAxis.max = 1000;
          valueAxis.strictMinMax = true;
        } else {
          this.noDataLabel.hide();
          valueAxis.max = undefined;
          valueAxis.strictMinMax = false;
        }
      });
    },
    updateChart(newData) {
      if (!this.chart) {
        return;
      }

      // Update chart data - the datavalidated event will handle the "No Data" label
      this.chart.series.clear();
      this.createSeries(this.chart, "value", "Value", this.colors[0]);
      this.chart.data = newData || [];
      this.chart.invalidateData();
    },
    createSeries(chart, field, name, color) {
      let series = new am4charts.ColumnSeries();
      chart.series.push(series);
      series.dataFields.valueY = field;
      series.dataFields.categoryX = "variant";
      series.name = name;
      series.stacked = true;
      series.columns.template.width = am4core.percent(32);
      series.columns.template.tooltipText = "{name}: [bold]{valueY}[/]";
      series.fill = am4core.color(color);
      series.stroke = am4core.color(color);

      series.tooltip.background.fill = am4core.color("#FFFFFF");
      series.tooltip.background.stroke = am4core.color("#CCCCCC");
      series.tooltip.background.strokeWidth = 1;
      series.tooltip.background.cornerRadius = 4;
      series.tooltip.getFillFromObject = false;
      series.tooltip.label.fill = am4core.color("#000000");

      let columnTemplate = series.columns.template;
      columnTemplate.column.cornerRadiusTopLeft = 8;
      columnTemplate.column.cornerRadiusTopRight = 8;
      columnTemplate.innerRadius = 8;
    },
  },
};
</script>

<style>
#QrOrdersLabelMakerByVariantChart {
  width: 100%;
  height: 320px;
}
</style>
